import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ title, children }) {
    return (
        <div className="min-h-screen grain relative bg-[#F8F9FA]">
            <header className="max-w-4xl mx-auto px-6 md:px-10 pt-8 pb-6 flex items-center justify-between relative z-10">
                <Link to="/" className="btn-pill" data-testid="back-home">
                    <ArrowLeft size={18} /> Back to ClearCursor
                </Link>
                <div className="font-display font-extrabold text-xl text-slate-900">
                    ClearCursor
                </div>
            </header>
            <main className="max-w-4xl mx-auto px-6 md:px-10 pb-16 relative z-10">
                <div className="card-bento" style={{ background: "#FFF7E0" }}>
                    <span className="tag">Legal</span>
                    <h1 className="font-display font-extrabold text-4xl md:text-5xl mt-4 text-slate-900">
                        {title}
                    </h1>
                    <p className="text-slate-700 mt-2">
                        Last updated: January 2026
                    </p>
                </div>
                <article className="card-bento mt-8 prose prose-lg max-w-none text-slate-800">
                    {children}
                </article>
            </main>
        </div>
    );
}
